import { Action } from '@ngrx/store';
import {
    GetLotsByAuctionId200Response,
    LotStatus,
} from '@viewbid/ts-angular-client';
export interface GenericActionPayload {
    data: string;
}

export enum SelectedAuctionUIActions {
    SelectAuctionAction = '[UI] Select Auction',
}

interface SelectAuctionActionProps {
    auctionId: string;
    page: number;
    size: number;
    auctionLotsId?: string;
    status: LotStatus | string;
}
export class SelectAuctionAction implements Action {
    readonly type: SelectedAuctionUIActions =
        SelectedAuctionUIActions.SelectAuctionAction;

    public props: SelectAuctionActionProps;

    constructor(props: SelectAuctionActionProps) {
        this.props = props;
    }
}

export enum SelectedAuctionLotsServiceActions {
    AuctionLotsFetchedSuccessfulAction = '[Get Auction Lots Service] Auction lots retrieved',
    AuctionLotsFetchedFailedAction = '[Get Auction Lots Service] Unable to retrieve auction lots',
}

export interface AuctionLotsFetchedSuccessfulActionProps {
    result: GetLotsByAuctionId200Response;
}

export class AuctionLotsFetchedSuccessfulAction implements Action {
    readonly type: SelectedAuctionLotsServiceActions =
        SelectedAuctionLotsServiceActions.AuctionLotsFetchedSuccessfulAction;

    public props: AuctionLotsFetchedSuccessfulActionProps;

    constructor(props: AuctionLotsFetchedSuccessfulActionProps) {
        this.props = props;
    }
}

export class AuctionLotsFetchedFailedAction implements Action {
    readonly type: SelectedAuctionLotsServiceActions =
        SelectedAuctionLotsServiceActions.AuctionLotsFetchedFailedAction;
}
